import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";
import { getConsent, setConsent } from "@/lib/analytics";
import { Link } from "react-router-dom";

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getConsent() === null) setVisible(true);
  }, []);

  if (!visible) return null;

  const handle = (v: "accepted" | "declined") => {
    setConsent(v);
    setVisible(false);
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-3 sm:p-4 pointer-events-none">
      <div className="pointer-events-auto max-w-4xl mx-auto bg-card border border-border shadow-2xl rounded-xl p-4 sm:p-5">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex items-start gap-3 flex-1">
            <div className="w-10 h-10 rounded-full bg-wine/10 flex items-center justify-center shrink-0">
              <Cookie className="w-5 h-5 text-wine" />
            </div>
            <div className="text-sm text-foreground/90 leading-relaxed">
              Usamos cookies para entender como você usa a Plateia.fun e melhorar sua experiência.
              Nenhum dado é compartilhado com terceiros.{" "}
              <Link to="/privacy" className="underline text-wine hover:text-wine/80">
                Saiba mais
              </Link>
              .
            </div>
          </div>
          <div className="flex gap-2 shrink-0">
            <Button variant="outline" size="sm" onClick={() => handle("declined")}>
              Recusar
            </Button>
            <Button variant="wine" size="sm" onClick={() => handle("accepted")}>
              Aceitar cookies
            </Button>
          </div>
          <button
            onClick={() => handle("declined")}
            className="hidden sm:block absolute top-2 right-2 p-1 text-muted-foreground hover:text-foreground"
            aria-label="Fechar"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
